
import {filter} from 'rxjs/operators';
import { Component, OnInit, OnDestroy } from '@angular/core';
import { State } from '@progress/kendo-data-query';
import { Observable, Subscription } from 'rxjs';
import { Router, ActivatedRoute, NavigationStart, NavigationEnd, RouteConfigLoadStart, RouteConfigLoadEnd, NavigationCancel, NavigationError } from '@angular/router';
import {ɵa} from 'angular2-prettyjson';


import { GrayBarHeaderComponent } from '../common/component/gray_bar_header/gray_bar_header.component';
import { UserProfileService, ProductRouteInfoService, ProductData } from '../core';


import {
  GridDataResult,
  DataStateChangeEvent
  } from '@progress/kendo-angular-grid';

@Component({
  selector: 'app-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy  {
public view: Observable<GridDataResult>;
  public state: State = {
    skip: 0,
    take: 5
  };
  productRouteInfo: ProductData[];
  subscriptions:Subscription[]=[];

  constructor(
    private userProfileService:UserProfileService
    ,private productRouteInfoService: ProductRouteInfoService
    ,private route: ActivatedRoute
    ,private router: Router
    ) {
      this.subscriptions.push(
          router.events.pipe(
          filter(event => event instanceof NavigationEnd))
          .subscribe(
            ((e:NavigationEnd) => {
              let current = this.router.routerState.snapshot.url;

              let  r = this.route.snapshot;
              this.productRouteInfo  = this.productRouteInfoService.Get(this.userProfileService.data.ProductAccess)
                .map(elem => {elem.path = elem.path.replace('main/','') ;return elem;});

              if(current === "/main" && this.productRouteInfo.length > 0 ) //if routed to main we may have to route back to default audit tab to update component
              {
                this.productRouteInfoService.NavigateToHighestPriorityProduct(this.userProfileService.data.ProductAccess,this.router);
              }

            }),
            (err)=>console.log(err)
          )
      );
    /*
//use when you need to see how routing behaves
      this.subscriptions.push(
        router.events
        //.filter(event => event instanceof NavigationEnd)
        .subscribe(
          ((e) => {
            let current =  this.router.routerState.snapshot.url;
            let sp = new SafeJsonPipe();
            let url="", redirect="";

            if(!(event instanceof RouteConfigLoadStart || event instanceof RouteConfigLoadEnd)){
              let d = <any>e;
              url = d.url;
              if(!(event instanceof NavigationCancel || event instanceof NavigationError)){
                redirect = d.urlAfterRedirects;
              }
            }
            if(event instanceof NavigationError){
              let ne:NavigationError = event;
              console.log(ne.error + " " + ne.id + " " + ne.url);
            }
            console.log(current + "  " +  e.constructor.name + " " + url + " " + redirect);
          }),
          (err)=>console.log(err)
        )
    );
    */
  }
  ngOnDestroy(){
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }
  ngOnInit() {

  }
  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
  }
}
